import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import styled from "styled-components";
import Header from "@/components/main/Header";
import Banner from "@/components/learn/Banner";
import Items from "@/components/learn/Items";
import How, { type THow } from "@/components/learn/How";
import YoutubeSlick, { type TYoutubeItem } from "@/components/learn/YoutubeSlick";
import TileBanner from "@/components/learn/TileBanner";
import OtherModels from "@/components/products/detail/OtherModels";
import ContactUs from "@/components/contact-us";
import Footer from "@/components/main/Footer";
import { TApplicationData } from "@/typings/Props";

const YoutubeSlickWrap = styled.div`
  background-color: #fff;
  margin: 50px 0;
  padding: 50px 0;
`;

const ClientWrap = styled.div`
  padding: 20px 0;
`;
const ClientTitle = styled.p`
  text-align: center;
  font-size: 2.7rem;
  font-weight: 700;
`;
const ClientItemWrap = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  padding: 30px;
`;
const ClientLogo = styled.img`
  width: 288px;
  object-fit: contain;
`;

export default function Page() {
  const { t } = useTranslation();
  const router = useRouter();
  const items: TApplicationData[] = [
    {
      id: 1,
      title: t("menu.learn.aesthetic.item.title-1"),
      desc: t("menu.learn.aesthetic.item.desc-1"),
      iconPath: "/learn/application/Enhance-Treatment-Precision.svg",
    },
    {
      id: 2,
      title: t("menu.learn.aesthetic.item.title-2"),
      desc: t("menu.learn.aesthetic.item.desc-2"),
      iconPath: "/learn/application/Differentiate-Your-Clinic.svg",
    },
    {
      id: 3,
      title: t("menu.learn.aesthetic.item.title-3"),
      desc: t("menu.learn.aesthetic.item.desc-3"),
      iconPath: "/learn/application/Additional-Revenue.svg",
    },
  ];

  const how: THow = {
    title: "menu.learn.aesthetic.how.title",
    img: "/learn/application/asthetic-result-image-scaled.webp",
    items: [
      {
        title: "menu.learn.aesthetic.how.item.title-1",
        desc: "menu.learn.aesthetic.how.item.desc-1",
      },
      {
        title: "menu.learn.aesthetic.how.item.title-2",
        desc: "menu.learn.aesthetic.how.item.desc-2",
      },
      {
        title: "menu.learn.aesthetic.how.item.title-3",
        desc: "menu.learn.aesthetic.how.item.desc-3",
      },
      {
        title: "menu.learn.aesthetic.how.item.title-4",
        desc: "menu.learn.aesthetic.how.item.desc-4",
      },
      {
        title: "menu.learn.aesthetic.how.item.title-5",
        desc: "menu.learn.aesthetic.how.item.desc-5",
      },
    ],
  };

  const youtubeItems: TYoutubeItem[] = [
    {
      title: t("menu.learn.aesthetic.youtube-item-1.desc.sub-title"),
      src: "https://www.youtube.com/embed/bcZZlo7p8y4?feature=oembed&enablejsapi=1&origin=https://inbodyasia.com",
      descSubTitle: t("menu.learn.aesthetic.youtube-item-1.desc.sub-title"),
      descTitle: t("menu.learn.aesthetic.youtube-item-1.desc.title"),
      desc: t("menu.learn.aesthetic.youtube-item-1.desc.desc"),
    },
  ];

  return (
    <>
      <Header />
      <Banner
        Bg="/learn/banner/Banner-3.png"
        Headline={t("menu.learn.banner.headline")}
        Title={t("menu.learn.aesthetic.banner.title")}
        Desc={t("menu.learn.aesthetic.banner.desc")}
      />

      <Items title={t("menu.learn.aesthetic.item.main-title")} items={items} />

      <How how={how} />

      <YoutubeSlickWrap>
        <YoutubeSlick youtubeItems={youtubeItems} />
      </YoutubeSlickWrap>
      <ClientWrap>
        <ClientTitle>{t("menu.learn.aesthetic.our-client")}</ClientTitle>
        <ClientItemWrap>
          <ClientLogo
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="100"
            data-aos-duration="500"
            src="/learn/application/aesthetic/slim-studio-logo.png"
          />
          <ClientLogo
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="150"
            data-aos-duration="500"
            src="/learn/application/aesthetic/drs-eye-asthetic-logo.png"
          />
          <ClientLogo
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="200"
            data-aos-duration="500"
            src="/learn/application/aesthetic/curvena-logo.png"
          />
          <ClientLogo
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="250"
            data-aos-duration="500"
            src="/learn/application/aesthetic/2024AHC_Logo.png"
          />
          <ClientLogo
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="300"
            data-aos-duration="500"
            src="/learn/application/aesthetic/premier-clinic-logo.png"
          />
          <ClientLogo
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="350"
            data-aos-duration="500"
            src="/learn/application/aesthetic/dr-d-logo.png"
          />
          <ClientLogo
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="400"
            data-aos-duration="500"
            src="/learn/application/aesthetic/slim-doc-logo.png"
          />
        </ClientItemWrap>
      </ClientWrap>
      <TileBanner
        backgroundImg={"/learn/application/medical/BookCover.png"}
        backgroundColor="#fff"
        title={t("menu.learn.fitness.download.title")}
        btn={{
          text: t("menu.learn.fitness.download.btn"),
          onClick: () => {
            router.push("/contact/contact-us");
          },
        }}
        isBottomDesc={true}
        negative
      />
      <OtherModels />
      <div style={{ margin: "50px 0 0 0" }} />
      <ContactUs />
      <Footer />
    </>
  );
}
